/** These are navigation URLs, never website Cookie values or account credentials. */
export function youtubeBrowserLinks(value:string|undefined,sessionId:string,origin:string){
 const invalid=()=>new Error('YouTube 登录窗口地址无效，请重新开始。');
 if(!/^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/i.test(sessionId))throw invalid();
 let url:URL;try{url=new URL(value??'',origin);}catch{throw invalid();}
 const base=new URL(origin),prefix=`/website-login/${sessionId}/`;
 if(!value || url.origin!==base.origin || url.username || url.password || url.search || url.hash || !url.pathname.startsWith(prefix) || !/^connect\/[A-Za-z0-9_-]{43}$/.test(url.pathname.slice(prefix.length)))throw invalid();
 return {initial:url.href,resume:new URL(prefix,base).href};
}
